export default "__VITE_ASSET__e46d0e2c__"